const scrollFunctions = () => {
    let scrollTopPositions = getScrollSectionTopPositions();

    ScrollTrigger.matchMedia({  
        // Wider and Taller Screen
        "(min-width: 992px) and (min-height: 700px)": function() {
            const scrollingSections = $('.js-scrolling-section');

            if ( scrollingSections.length > 1 ) {
                let tl = gsap.timeline({paused: true});
                
                $('.home .content-wrapper').fullpage({
                    sectionSelector: '.js-scrolling-section',
                    navigation: false,
                    scrollOverflow: false,
                    scrollingSpeed: 1000,
                    bigSectionsDestination: 'top',
                    afterLoad: function(origin, destination, direction) {
                        if ( destination.item.classList.contains('ci-block') ) {
                            CustomEase.create('headingEase', '0.165, 0.84, 0.44, 1.00');
                    
                            const imagesContainer = destination.item.querySelector('.ci-block__images-container');
                            const headingLines = destination.item.querySelectorAll('.js-split-text-line');
                            const subheading = destination.item.querySelector('.ci-block__subheading');
                            const content = destination.item.querySelectorAll('.ci-block__content .u-wysiwyg');
                            const sliderNav = destination.item.querySelectorAll('.c-slider-nav');
                            const buttons = destination.item.querySelectorAll('.ci-block__buttons');

                            const contentAnimObj = { opacity: 1, y: 0, duration: 1 };

                            tl.addLabel('startAnimations');
                            if ( headingLines.length ) {
                                const headingDelay = 0.1;
        
                                headingLines.forEach((line, i) => {
                                    tl.to(line.querySelectorAll('span'), { opacity: 1, ease: 'headingEase', duration: 0.3 }, 'startAnimations+=' + ((i + 1) * headingDelay));
                                    tl.to(line.querySelectorAll('span'), { opacity: 1, y: 0, ease: 'headingEase', duration: 0.8 }, 'startAnimations+=' + ((i + 1) * headingDelay));
                                });
                            }
                            tl.to(imagesContainer, contentAnimObj, 'startAnimations+=0.4');
                            tl.addLabel('contentAnimations', 'startAnimations');
                            if ( subheading ) {
                                tl.to(subheading, contentAnimObj, 'contentAnimations');
                            }
                            if ( content ) {
                                tl.to(content, contentAnimObj, 'contentAnimations');
                            }
                            if ( sliderNav ) {
                                tl.to(sliderNav, contentAnimObj, 'contentAnimations');
                            }
                            if ( buttons ) {
                                tl.to(buttons, contentAnimObj, 'contentAnimations');
                            }

                            if ( direction == 'down' ) {
                                tl.play();
                            }
                        }
                    },
                    onLeave: function(origin, destination, direction, trigger) {
                        // Toggle visibility of scrollTop element
                        if ( destination.item.classList.contains('hero-section') ) {
                            $('.c-scroll-top').fadeOut(500);
                        } else {
                            $('.c-scroll-top').fadeIn(500);
                        }

                        if ( destination.item.classList.contains('ci-block') ) {
                            const sectionBackgroundColour = destination.item.dataset.bg;

                            $('.c-header .c-header__btn-container .c-btn').attr('data-text-hover', sectionBackgroundColour);
                        }

                        // Toggle Dark Class On Header and Scroll Top
                        if ( destination.item.classList.contains('ci-block--cream') ) {
                            $('.c-header').addClass('c-header--dark');
                            $('.c-scroll-top').addClass('c-scroll-top--dark');
                        } else {
                            $('.c-header').removeClass('c-header--dark');
                            $('.c-scroll-top').removeClass('c-scroll-top--dark');
                        }

                        // Remove Header when scrolling into footer
                        if ( destination.item.classList.contains('c-footer') ) {
                            $('.c-header').fadeOut(500);
                        } else {
                            $('.c-header').fadeIn(500);
                        }
                    }
                });

                scrollSectionsDesktop();
            }        
        },
        // Wider and Smaller Screens
        "(min-width: 992px) and (max-height: 699px)": function() {
            scrollSectionsMobile(scrollTopPositions);
        },       
        // Smaller Screens
        "(min-width: 576px) and (max-width: 991px)": function() {
            scrollTopFunctions(window);
        },
        "(max-width: 991px)": function() {
            scrollSectionsMobile(scrollTopPositions);
            scrollTopFunctions(window);
        }
    });      
};

const scrollSectionsMobile = (scrollTopPositions) => {
    $(document).on('click', '.home .js-scroll-section', function(e) {
        e.preventDefault();

        const scrollSectionID = $(this).data('section') == 'next' ? '#' + $(this).closest('section').next('section').attr('id') : $(this).data('section');
        let scrollObject = scrollTopPositions.find(o => o.id === scrollSectionID);
        
        gsap.to(window, {
            scrollTo: { y: scrollObject.y, autoKill: false },
            duration: 1,
        });
    });  
};

const scrollSectionsDesktop = () => {
    $(document).on('click', '.home .js-scroll-section', function(e) {
        e.preventDefault();

        let scrollIndex = $(this).data('scroll-index');
        scrollIndex = ( scrollIndex == 'top' ) ? 1 : scrollIndex;
        scrollIndex = ( scrollIndex == 'next' ) ? 2 : scrollIndex;
        scrollIndex = parseInt(scrollIndex);

        fullpage_api.moveTo(scrollIndex);
    });  

    if ( $('body').hasClass('home') ) {
        $('.c-nav-items__link').each(function() {
            const section = $(this).data('section');
            let scrollIndex = $(this).data('scroll-index');
            scrollIndex = ( scrollIndex == 'top' ) ? 1 : scrollIndex;
            scrollIndex = ( scrollIndex == 'next' ) ? 2 : scrollIndex;
            scrollIndex = parseInt(scrollIndex);

            if (window.location.href.indexOf(section) > -1) {
                fullpage_api.moveTo(scrollIndex);
            }
        });
    }
};

const scrollTopFunctions = (scrollElem) => {
    gsap.utils.toArray('.ci-block--cream').forEach((el, i) => {
        ScrollTrigger.create({
            scroller: scrollElem,
            trigger: el,
            start: () => {
                const elem = document.querySelector('.c-scroll-top');
                const elemHeight = elem.clientHeight;
                const elemRect = elem.getBoundingClientRect();
    
                return 'top top+=' + (elemHeight + elemRect.top);
            },
            end: 'bottom top',
            toggleClass: {
                targets: '.c-scroll-top',
                className: 'c-scroll-top--dark'
            }
        });
    });

    let fadeInScrollElem = gsap.to('.c-scroll-top', { opacity: 1, duration: 0.6 });
    let fadeInScrollElemTrigger = ScrollTrigger.create({
        scroller: scrollElem,
        trigger: '.ci-block.module-2',
        start: () => {
            const elem = document.querySelector('.c-scroll-top');
            const elemHeight = elem.clientHeight;
            const elemRect = elem.getBoundingClientRect();

            return 'top top+=' + (elemHeight + elemRect.top);
        },
        end: 'bottom top',
        toggleActions: 'play complete none reverse',
        animation: fadeInScrollElem
    });   
};

const getScrollSectionTopPositions = () => {
    let scrollTopPositions = [];

    $('.home .js-scroll-section').each(function() {
        const scrollSectionID = $(this).data('section') == 'next' ? '#' + $(this).closest('section').next('section').attr('id') : $(this).data('section');
        let yVal;

        if ( scrollSectionID == 'top' ) {
            yVal = 0;
        } else {
            const elem = document.querySelector(scrollSectionID + ' .ci-block__inner');
            const elemRect = elem.getBoundingClientRect();

            yVal = elemRect.top;
        }
        
        const scrollObject = {id: scrollSectionID, y: yVal};

        if ( !containsObject(scrollObject, scrollTopPositions) ) {
            scrollTopPositions.push(scrollObject);
        }
    });

    return scrollTopPositions;
}

const containsObject = (obj, list) => {
    var i;
    for (i = 0; i < list.length; i++) {
        if (list[i].id === obj.id) {
            return true;
        }
    }

    return false;
};


